import { BlogSection } from '@/types/blog';

export const meat_loaf_revisited: BlogSection = {
  id: 'meat-loaf-revisited',
  title: 'Meat Loaf Revisited',
  content: `
    <p class="text-xl font-semibold text-joerg-800 dark:text-joerg-100">"I would do anything for love, but I won't do that."</p>

    <p>Was ist „<em>das</em>"?</p>

    <p><strong>Meine These (durch Fromm):</strong></p>

    <p>„<em>Das</em>" = Den anderen besitzen wollen.</p>

    <p>Meat Loaf singt nicht über Liebe im Haben-Modus („Ich muss dich haben").</p>

    <p>Er singt über Liebe im Sein-Modus:</p>

    <p class="text-joerg-700 dark:text-joerg-300 mt-4">In Interviews erklärte Meat Loaf, dass das „<em>that</em>" in seinem berühmten Refrain immer auf die Zeile davor verweist – also auf ein konkretes Versprechen, das er nicht brechen will. In jeder Strophe sagt er, was er tun würde – und nennt dann eine einzige Sache, die er nicht tun wird.</p>

    <p class="font-semibold text-joerg-800 dark:text-joerg-100 mt-4">„<em>That</em>" ist kein Mysterium, keine Abwehr. Es ist Integrität.</p>

    <p class="text-joerg-700 dark:text-joerg-300">Es bedeutet: Ich liebe – aber ich verliere mich dabei nicht.</p>

    <p class="mt-4">Damit singt Meat Loaf nicht über romantische Hingabe, sondern über reife Liebe. Über die Fähigkeit, in Beziehung zu bleiben, ohne sich selbst aufzugeben.</p>

    <p class="font-semibold text-joerg-800 dark:text-joerg-100 mt-4">Genau hier berührt sich Popkultur mit Fromm:</p>
    <p class="text-joerg-700 dark:text-joerg-300">Liebe ohne Besitz. Nähe ohne Verschmelzung. Sein statt Haben.</p>

    <div class="bg-gradient-to-br from-joerg-50 to-primary/10 dark:from-joerg-900 dark:to-primary/20 p-6 rounded-lg border border-joerg-200 dark:border-joerg-700 my-6">
      <ul class="space-y-3 text-joerg-700 dark:text-joerg-300">
        <li>✓ Ich gebe alles (Fürsorge, Verantwortung, Respekt, Erkenntnis).</li>
        <li>✓ <strong>Aber:</strong> Ich werde dich nicht kontrollieren, nicht besitzen, nicht ändern wollen.</li>
      </ul>
    </div>

    <p class="text-lg font-semibold text-joerg-800 dark:text-joerg-100 mt-6">Das ist reife Liebe.</p>
    <p class="text-lg font-semibold text-joerg-800 dark:text-joerg-100">Das ist die Kunst des Liebens.</p>
  `
};
